import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  large: {
    width: '9rem',
  },
}));